import JobCustomersPage from '@/pages/jobs/customers'
import { WorkspacePortalProvider } from '@/contexts/workspace-portal-context'

export default function EventCustomersPage() {
  return (
    <WorkspacePortalProvider mode="event">
      <JobCustomersPage />
    </WorkspacePortalProvider>
  )
}
